<svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
	<circle cx="15" cy="15.5" r="10" fill="#4F4F4F" />
	<line x1="18.2458" y1="10.8927" x2="12.3927" y2="19.2542" stroke="white" stroke-width="2" stroke-linecap="round" />
	<circle cx="15" cy="15.5" r="1.5" fill="white" stroke="#4F4F4F" />
</svg>
